namespace $.$$ {
	
	$mol_style_define( $gd_web_frame, {
		
		flex: {
			basis: '4rem',
			shrink: 0,
			grow: 0,
		},
		
	} )
	
}
